export const PH_NUMBERED_LIST = [
  {
    label: 'Get Deals Up to 70% Off',
    content:
      'Get full-sized, high-quality products at a fraction of the retail cost.',
  },
  {
    label: 'Price Match Guarantee',
    content: 'Find a cheaper product elsewhere? We can match that price.',
    termsLink:
      "https://support.fabfitfun.com/?a=What-is-FabFitFun's-Price-Match-Guarantee---id--irEl2lfJSZWdxOrn7RLFWw",
  },
  {
    label: 'Build Your Perfect Box',
    content: 'Choose your products each season or just shop our sales instead!',
  },
];

export const PH_FEATURE_LIST_WHITE = [
  {
    image: 'https://scontent01.fabfitfun.com/pandora/cdn/openbox.png',
    label: 'Customize',
    content:
      'Each season, we curate a box of the hottest deals. You make it 100% you.',
  },
  {
    image: 'https://scontent01.fabfitfun.com/pandora/cdn/swap.png',
    label: 'Stay in Control',
    content:
      'Not in love with the season’s choices? You can always skip for credit to shop.',
  },
  {
    image: 'https://scontent01.fabfitfun.com/pandora/cdn/fullsize.png',
    label: 'Shop Anytime',
    content: 'Shop and save with our curated weekly sales.',
  },
];

export const PH_FEATURE_LIST_BEIGE = [
  {
    image: 'https://scontent01.fabfitfun.com/pandora/cdn/crown.svg',
    label: 'We Help Brands Grow',
    content:
      'We get access to the best, in demand brands because we help them grow their business',
  },
  {
    image: 'https://scontent01.fabfitfun.com/pandora/cdn/box-open-full.svg',
    label: 'By Placing Big Orders',
    content:
      'FabFitFun uses member insights and places massive orders on the latest trends and receives heavy discounts',
  },
  {
    image: 'https://scontent01.fabfitfun.com/pandora/cdn/message-dollar.svg',
    label: 'To Help Members Save',
    content:
      'FabFitFun members get up to 70% off, early access and exclusive drops from the most in demand brands',
  },
];

export const PARIS_HILTON_SKU = 'MIN-BO-060';
